import { render, staticRenderFns } from "./ContactAddressList.vue?vue&type=template&id=2d7b29aa&scoped=true"
import script from "./ContactAddressList.vue?vue&type=script&lang=js"
export * from "./ContactAddressList.vue?vue&type=script&lang=js"
import style0 from "./ContactAddressList.vue?vue&type=style&index=0&id=2d7b29aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7b29aa",
  null
  
)

export default component.exports